import {Component, EventEmitter, Input, Output} from '@angular/core';

import {SlideInOutAnimation} from '@src/app/animations/slideInOutAnimation';
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';
import {IUserGuide} from '../../shared/user-guide.model';
import {UserGuideStore} from '../../shared/user-guide.store';
import {UiAdapterService} from '@src/app/services/uiAdapterService/ui-adapter.service';
import { DrawingEditorToolsService } from '@src/app/components_2.1/drawing-editor-tools/drawing-editor-tools.service';

@Component({
  selector: 'app-user-guide-accordion-item',
  templateUrl: './user-guide-accordion-item.component.html',
  styleUrls: ['./user-guide-accordion-item.component.scss'],
  animations: [SlideInOutAnimation],
})
export class UserGuideAccordionItemComponent {
  @Input() userGuideItem: IUserGuide;
  @Output() toggleSection: EventEmitter<IUserGuide> = new EventEmitter();

  constructor(
    private userGuideStore: UserGuideStore,
    private itemManagerService: ItemManagerService,
    private uiAdapterService: UiAdapterService,
    private drawingEditorToolsService: DrawingEditorToolsService,
  ) {}

  get animationState() {
    return this.userGuideItem.isActive ? 'open' : 'close';
  }

  start(): void {
    this.itemManagerService.clearSelectedItems();
    this.uiAdapterService.hiddenDetailsSidebar = true;
    this.drawingEditorToolsService.collapseGroups();
    this.userGuideStore.setActiveStep(this.userGuideItem.index, 0);
  }
}
